import { useTranslation } from "react-i18next";
import style from "../sass/custom/buttons.module.scss";
import { useEffect } from "react";
import { i18nLangs } from "../data/static-data";

const SwitchLang = () => {
    const { i18n } = useTranslation();

    const handleChangeLang = async (lang) => {
        i18n.changeLanguage(lang);
    };

    useEffect(() => {
        (async function () {
            if (i18n.language === "ru-RU" || i18n.language === "ru") {
                i18n.changeLanguage(i18nLangs.RU);
                return
            }
            i18n.changeLanguage(i18nLangs.TR);
        })();
    }, [i18n]);

    return (
        <div className="flex flex-col justify-evenly">
            <div>
                <button
                    style={{
                        minWidth: "2.5rem",
                    }}
                    onClick={() => handleChangeLang("ru")}
                    className={`${style.btn} ${style["btn-primary"]} text-xs ${
                        i18n.language === i18nLangs.RU ? style.active : style.inactive
                    }`}
                >
                    RU
                </button>
            </div>
            <div>
                <button
                    style={{
                        minWidth: "2.5rem",
                    }}
                    onClick={() => handleChangeLang("tr")}
                    className={`${style.btn} ${style["btn-primary"]} text-xs  ${
                        i18n.language === i18nLangs.TR ? style.active : style.inactive
                    }`}
                >
                    TR
                </button>
            </div>
        </div>
    );
};

export default SwitchLang;
